import { HttpClient } from '@root/src/lib/HttpClient';

const localFallbackBanner = {
  imagePath: '/images/contact.webp',
  title: '',
  text: '',
};

function normalizeAppearUrl(value?: string) {
  return value?.trim().replace(/\/+$/, '') || '';
}

function resolveAppear(appear?: string) {
  if (appear && appear !== 'undefined' && appear !== 'null') {
    return normalizeAppearUrl(appear);
  }
  if (process.env.NEXT_PUBLIC_APPEAR) {
    return normalizeAppearUrl(process.env.NEXT_PUBLIC_APPEAR);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return normalizeAppearUrl(window.location.origin);
  }
  return '';
}

function normalizeBannerItem(item: any) {
  if (!item) {
    return null;
  }

  return {
    ...item,
    imagePath: item.imagePath || item.value || localFallbackBanner.imagePath,
    title: item.title || '',
    text: item.text || '',
    appear: normalizeAppearUrl(item.appear),
    visible:
      typeof item.visible === 'string' ? item.visible.toLowerCase() : item.visible,
  };
}

function selectBannerItem(item: any, appear?: string) {
  if (!item) {
    return localFallbackBanner;
  }

  const normalizedAppear = resolveAppear(appear);
  const items = Array.isArray(item) ? item : [item];
  const normalizedItems = items.map(normalizeBannerItem).filter(Boolean);

  const matchedVisibleBanner =
    normalizedItems.find(
      banner =>
        banner.visible === 'true' &&
        (!normalizedAppear || !banner.appear || banner.appear === normalizedAppear)
    ) ||
    normalizedItems.find(
      banner =>
        !normalizedAppear || !banner.appear || banner.appear === normalizedAppear
    ) ||
    normalizedItems.find(banner => banner.visible === 'true') ||
    normalizedItems[0];

  return matchedVisibleBanner || localFallbackBanner;
}

export async function fetchBanner(appear?: string) {
  try {
    const data = await HttpClient.httpGet('/configuration/key/Banner1');
    if (!data.success) {
      return localFallbackBanner;
    }
    return selectBannerItem(data?.item, appear);
  } catch (error) {
    return localFallbackBanner;
  }
}

export async function fetchPopup() {
  try {
    const data = await HttpClient.httpGet('/configuration/key/popup');
    if (!data.success) {
      return localFallbackBanner;
    }
    return data?.item;
  } catch (error) {
    return localFallbackBanner;
  }
}

export async function fetchBanner2() {
  try {
    const data = await HttpClient.httpGet('/configuration/key/Banner2');
    if (!data.success || !data.item || !data.item.imagePath) {
      return localFallbackBanner;
    }
    return data.item;
  } catch (error) {
    return localFallbackBanner;
  }
}

export async function fetchBanner3() {
  try {
    const data = await HttpClient.httpGet('/configuration/key/Banner3');
    if (!data.success || !data.item || !data.item.imagePath) {
      return localFallbackBanner;
    }
    return data.item;
  } catch (error) {
    return localFallbackBanner;
  }
}

export async function fetchBanner4() {
  try {
    const data = await HttpClient.httpGet(
      '/configuration/key/BannerAppointment'
    );
    if (!data || !data.item) {
      return localFallbackBanner;
    }
    return data.item;
  } catch (error) {
    return localFallbackBanner;
  }
}

export async function fetchBanner5() {
  try {
    const data = await HttpClient.httpGet('/configuration/key/BannerContact');
    if (!data.success || !data.item || !data.item.imagePath) {
      return localFallbackBanner;
    }
    return data.item;
  } catch (error) {
    return localFallbackBanner;
  }
}

export async function fetchBannerProductDetail(appear?: string) {
  try {
    const data = await HttpClient.httpGet('/configuration/key/BannerProductDetail');
    if (!data.success || !data.item) {
      return null;
    }

    const selectedBanner = selectBannerItem(data?.item, appear);
    if (!selectedBanner?.imagePath || selectedBanner.imagePath === localFallbackBanner.imagePath) {
      return null;
    }

    return selectedBanner;
  } catch (error) {
    return null;
  }
}

export async function fetchBanner6() {
  try {
    const data = await HttpClient.httpGet('/configuration/key/config6');
    if (!data.success || !data.item || !data.item.imagePath) {
      return '/images/24-2 3.JPG';
    }
    return data.item;
  } catch (error) {
    return '/images/24-2 3.JP';
  }
}
